export const environment = {
    production: false,
    apiUrl: 'soilguard.wings-ict-solutions.dev',
    apiType: "https",
    apiPort: "",
    enableDebug: false,
     keycloakRealm: "soilguard",
    keycloakClientId: "soilguard-client",
    keycloakUrl:  "https://sso.wings-ict-solutions.dev/auth",
    uruguayFeatures: false,
    greekFeatures: false,
    soilguardFeatures: true
  };
  